import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setValueOptions } from '../../../store/actions/setting'
import { getValueOption, valueOption } from '../../../store/selectors/selectors'
import { getUrlImg } from '../../../utils/utilsFunctions';
//@ts-ignore
import s from './ImgRadio.module.scss'

type items = {
    id: string
    imgUrl: string
    parentKeySection?: unknown
}

export const ImgRadio = ({ ...props }: any) => {

    let { id, parentKeySection } = props

    let { selectValue, isError }: valueOption = useSelector(state => getValueOption({ idOptions: id, parentKeySection })(state));

    const dispatch = useDispatch();

    function onChange(value: any) {

        dispatch(setValueOptions({ idParams: id, valueParam: value, parentKeySection: parentKeySection }))
    }

    return (
        <div className={s.boxItems}>
            {props['values'].map((item: items) => {
                let classItem = `${s.itemClass}`;
                if (selectValue === item['id']) classItem += ` ${s.active}`

                return (
                    <div className={classItem} onClick={() => onChange(item['id'])}>
                        <img src={getUrlImg(item['imgUrl'])} alt="" />
                    </div>
                )

            })}
        </div >
    )
}
